import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Sparkles } from "lucide-react";
import { useCart } from "../context/CartContext";

const money = (n) => `$${Number(n).toFixed(2)}`;

const ThankYou = () => {
  const { clearCart } = useCart();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    let data = null;
    try {
      const raw = localStorage.getItem("flowlux_last_order");
      if (raw) data = JSON.parse(raw);
    } catch (e) {}
    setOrder(data);

    // Clear the cart now that the purchase is complete.
    clearCart();

    // Fire the Google Ads conversion event for this purchase.
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-18458323245",
        value: data?.total || 0,
        currency: "USD",
        transaction_id: data?.order_number || "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="min-h-[75vh] flex items-center justify-center bg-[#F4EFE8] px-6 py-24">
      <div className="w-full max-w-md text-center" data-testid="thankyou-page">
        <CheckCircle2 size={58} strokeWidth={1.2} className="mx-auto mb-6 text-[#8a6d3b]" />
        <p className="text-[12px] tracking-[0.3em] uppercase text-[#8a6d3b] mb-3">Order Confirmed</p>
        <h1 className="font-serif-display text-[40px] md:text-[46px] leading-[1.05] font-medium mb-4" data-testid="thankyou-title">
          Thank you for your purchase!
        </h1>
        <p className="text-[15px] text-[#1A1A1A]/70 leading-relaxed mb-8">
          Your glow up is on its way. We've emailed your confirmation
          {order?.email ? <> to <strong>{order.email}</strong></> : null} and your order ships free within 5 days.
        </p>

        {order && (
          <div className="text-left bg-white rounded-sm border border-[#1A1A1A]/12 p-6 mb-8" data-testid="thankyou-summary">
            {order.order_number && (
              <div className="flex items-center justify-between pb-4 mb-4 border-b border-[#1A1A1A]/10">
                <span className="text-[12px] tracking-[0.08em] uppercase text-[#1A1A1A]/55">Order</span>
                <span className="text-[14px] font-medium" data-testid="thankyou-order-number">{order.order_number}</span>
              </div>
            )}
            <div className="space-y-3">
              {(order.items || []).map((it, i) => (
                <div key={i} className="flex items-center justify-between">
                  <span className="text-[14px] flex items-center gap-2">
                    <Sparkles size={14} className="text-[#8a6d3b]" />
                    {it.title}
                  </span>
                  <span className="text-[14px] text-[#1A1A1A]/70">{money(it.price)}</span>
                </div>
              ))}
            </div>
            {typeof order.total === "number" && (
              <div className="flex items-center justify-between pt-4 mt-4 border-t border-[#1A1A1A]/10">
                <span className="text-[13px] tracking-[0.06em] uppercase">Total</span>
                <span className="text-[16px] font-medium">{money(order.total)}</span>
              </div>
            )}
          </div>
        )}

        <Link
          to="/"
          data-testid="thankyou-continue-btn"
          className="btn-lux inline-block px-10 py-4 text-[12px] tracking-[0.22em] uppercase"
        >
          Continue Shopping
        </Link>
      </div>
    </main>
  );
};

export default ThankYou;
